document.addEventListener('DOMContentLoaded', function () {
  initMultiColumnVideos(document);

  document.querySelectorAll('.gm-tabbed-column').forEach(function (root) {
    if (root.dataset.tabsInitialized === 'true') return;
    root.dataset.tabsInitialized = 'true';

    var triggers = root.querySelectorAll('[data-tab-trigger]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    var defaultTab = root.getAttribute('data-default-tab') || '1';

    function setTab(tabId) {
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === tabId);
      });

      triggers.forEach(function (trigger) {
        var isActive = trigger.getAttribute('data-tab-trigger') === tabId;
        var activeBg = trigger.getAttribute('data-active-bg');
        var activeText = trigger.getAttribute('data-active-text');
        var inactiveBg = trigger.getAttribute('data-inactive-bg');
        var inactiveText = trigger.getAttribute('data-inactive-text');

        trigger.style.background = isActive ? activeBg : inactiveBg;
        trigger.style.color = isActive ? activeText : inactiveText;
        trigger.style.borderColor = isActive ? activeBg : inactiveText;
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setTab(trigger.getAttribute('data-tab-trigger'));
      });
    });

    setTab(defaultTab);
  });
});

document.addEventListener('shopify:section:load', function (event) {
  initMultiColumnVideos(event.target);

  event.target.querySelectorAll('.gm-tabbed-column').forEach(function (root) {
    if (root.dataset.tabsInitialized === 'true') return;
    root.dataset.tabsInitialized = 'true';

    var triggers = root.querySelectorAll('[data-tab-trigger]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    var defaultTab = root.getAttribute('data-default-tab') || '1';

    function setTab(tabId) {
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === tabId);
      });

      triggers.forEach(function (trigger) {
        var isActive = trigger.getAttribute('data-tab-trigger') === tabId;
        var activeBg = trigger.getAttribute('data-active-bg');
        var activeText = trigger.getAttribute('data-active-text');
        var inactiveBg = trigger.getAttribute('data-inactive-bg');
        var inactiveText = trigger.getAttribute('data-inactive-text');

        trigger.style.background = isActive ? activeBg : inactiveBg;
        trigger.style.color = isActive ? activeText : inactiveText;
        trigger.style.borderColor = isActive ? activeBg : inactiveText;
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setTab(trigger.getAttribute('data-tab-trigger'));
      });
    });

    setTab(defaultTab);
  });
});

function initMultiColumnVideos(root) {
  var scope = root || document;
  var triggers = scope.querySelectorAll('[data-multi-column-video-trigger]');

  triggers.forEach(function (trigger) {
    if (trigger.dataset.videoInitialized === 'true') return;
    trigger.dataset.videoInitialized = 'true';

    trigger.addEventListener('click', function () {
      var figure = trigger.closest('.multi-column__grid-item-image-figure');
      if (!figure) return;

      var template = figure.querySelector('[data-multi-column-video-template]');
      if (!template) return;

      openMultiColumnVideoLightbox(template.innerHTML);
    });
  });
}

function openMultiColumnVideoLightbox(html) {
  var existing = document.querySelector('.multi-column-video-lightbox');
  if (existing) existing.remove();

  var wrapper = document.createElement('div');
  wrapper.className = 'multi-column-video-lightbox';
  wrapper.innerHTML =
  '<div class="modal active multi-column-video-modal">' +
    '<div class="modal__wash" data-mcv-close></div>' +
    '<div class="modal__inner multi-column-video-modal__inner" data-scroll-lock-ignore>' +
      '<div class="modal__header">' +
        '<button type="button" class="modal__close-icon multi-column-video-modal__close" data-mcv-close aria-label="Cerrar">×</button>' +
      '</div>' +
      '<div class="modal__content multi-column-video-modal__content">' + html + '</div>' +
    '</div>' +
  '</div>';
  var modal = wrapper.querySelector('.modal');
  document.body.appendChild(wrapper);
  document.body.classList.add('mcv-lightbox-open');

  document.body.appendChild(wrapper);
  document.body.classList.add('mcv-lightbox-open');

  bindMultiColumnVideoPlayers(wrapper);
  bindMultiColumnLightboxClose(wrapper);
}

function bindMultiColumnLightboxClose(wrapper) {
  wrapper.querySelectorAll('[data-mcv-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeMultiColumnVideoLightbox(wrapper);
    });
  });

  function handleEscape(event) {
    if (event.key === 'Escape') {
      closeMultiColumnVideoLightbox(wrapper);
      document.removeEventListener('keydown', handleEscape);
    }
  }

  document.addEventListener('keydown', handleEscape);
}

function closeMultiColumnVideoLightbox(wrapper) {
  var iframe = wrapper.querySelector('iframe');
  var video = wrapper.querySelector('video');

  if (video) {
    video.pause();
  }

  if (iframe) {
    iframe.src = iframe.src;
  }

  wrapper.remove();
  document.body.classList.remove('mcv-lightbox-open');
}

function bindMultiColumnVideoPlayers(wrapper) {
  var external = wrapper.querySelector('.multi-column__lightbox-video[data-video-provider][data-video-id]');
  var nativeVideo = wrapper.querySelector('video');

  if (nativeVideo) {
    nativeVideo.play().catch(function () {});
    return;
  }

  if (!external) return;

  var provider = external.getAttribute('data-video-provider');
  var videoId = external.getAttribute('data-video-id');

  if (provider === 'youtube') {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&playsinline=1';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');
    external.replaceWith(iframe);
    return;
  }

  if (provider === 'vimeo') {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');
    external.replaceWith(iframe);
  }
}